import type { ProtoMetricCategory } from "@catbento/shared";
import { getMetricCategories } from "../data/stats.js";

// Phase 02 seam: the stat category config (appearance/passing/attacking/
// defending/goalkeeping → subcategories → metrics). Fixed config, the same in both
// modes (data/stats.ts says why it isn't read from the snapshot or the API).
export function useMetricCategories(): ProtoMetricCategory[] {
  return getMetricCategories();
}
